// Un dato, un render (AGENTS.md): quién puede tocar el MAPA de ubicaciones se
// decide aquí y en ningún otro sitio. Estaba escrito inline en el tablero de
// stock y olvidado en Almacén, así que el staff seguía viendo el botón
// "Ubicaciones" y solo cosechaba un 403 del backend.
//
// Decidido 09-08-2026: crear/renombrar/borrar ubicaciones y el semáforo
// dispensable son ESTRUCTURA del club → owner/superadmin. El staff sigue
// leyendo la lista y MOVIENDO stock (entradas, traspasos, ajustes), que es
// operativa diaria y vive en otros endpoints.

export function roleOf(accessPrivileges) {
  return String(accessPrivileges?.value ?? accessPrivileges ?? '').toLowerCase();
}

// Espejo exacto de `auth_service.owner_privileges` en el backend (POST/PATCH/
// DELETE /v1/stock/locations). Si esto y el backend se separan, el usuario ve
// botones que fallan — que es justo el lío que hubo con ubicaciones.
export function canEditStockLocations(accessPrivileges) {
  return ['owner', 'superadmin'].includes(roleOf(accessPrivileges));
}
